import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PickingService from '../../../../services/PickingService';
import { Input, Button, Breadcrumbs, ScannerCode } from '../../../../components/UI/ComponentsUI';
import { translate, isNullOrEmpty } from '../../../../utils/util';
import { validateInputsRequired } from '../../../../utils/handleChangeHooks';

const InsertInvoice = (props) => {
    const [invoice, setInvoice] = useState('');
    const [selectedFile, setSelectedFile] = useState();
    // const [base64, setBase64] = useState();

    const scanner = (value) => {
        if (!isNullOrEmpty(value) && value.length === 44) {
            setInvoice(value);
        }
    };

    // const onCamera = (value) => {
    //     if (!isNullOrEmpty(value)) {
    //         setSelectedFile(null);
    //         setBase64(value);
    //     }
    // };

    const onConfirm = () => {
        if (validateInputsRequired('formInvoice') && selectedFile) {
            props.sendInvoice(selectedFile, invoice, () => {
                setInvoice('');
                setSelectedFile(null);
            })
        }
    };

    return (
        <div>
            <Breadcrumbs id="pickinginvoice" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('expedition:picking.insert-invoice') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className='container'>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formInvoice" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <ScannerCode onScanner={scanner} />
                                    <Input
                                        required
                                        label={translate('expedition:picking.key-invoice')}
                                        id="invoice"
                                        name="invoice"
                                        type="number"
                                        minLength="44"
                                        maxLength="44"
                                        defaultValue={invoice}
                                        onChange={(event) => {
                                            if (event.currentTarget.value.length === 44) {
                                                setInvoice(event.currentTarget.value)
                                            } else {
                                                event.currentTarget.value = event.currentTarget.value.length > 44
                                                    ? event.currentTarget.value.substring(0, 44) : event.currentTarget.value

                                                setInvoice(event.currentTarget.value);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) => {
                                            setSelectedFile(event.target.files[0])
                                        }}
                                    />
                                    {
                                        selectedFile &&
                                        <div className="list sixth-text-color">
                                            <i onClick={() => {
                                                setSelectedFile();
                                            }} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                        </div>
                                    }
                                </div>
                                {/* <div className="input-field padding col s6" style={{ paddingBlockEnd: '40px' }}>
                                    <CameraPicture onCam={(evt) => onCamera(evt)} />
                                </div>
                                {
                                    base64 &&
                                    <>
                                        <div className="input-field padding col s6">
                                            <i onClick={() => setBase64()} style={{ top: '0rem' }} className={`mdi mdi-46px mdi-alpha-x-circle-outline`} />

                                        </div>
                                        <div className="input-field padding col s12" style={{ paddingTop: '10px' }}>

                                            <img id="imgElem" style={{ width: '100%' }} alt="NF" src={"data:image/jpg;base64," + base64} />
                                        </div>
                                    </>
                                } */}
                                {
                                    selectedFile &&
                                    <div className="input-field padding col s12" style={{ paddingTop: '10px' }}>
                                        <img style={{ width: '100%' }} alt="NF" src={URL.createObjectURL(selectedFile)} />
                                    </div>
                                }
                            </div>

                            <div className="row" style={{ marginTop: '20px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendInvoice: (selectedFile, invoiceKey, callback) => {
            dispatch(PickingService.InsertInvoice(selectedFile, invoiceKey, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InsertInvoice)));